/**
 * Local client-only OS platform detection and shortcut formatting.
 *
 * PRIVACY NOTE:
 * OS detection is performed 100% locally in-browser via standard client properties
 * (navigator.userAgentData?.platform, navigator.platform, navigator.userAgent).
 * No hardware data, telemetry, or user identifiers are collected, logged, or transmitted.
 */

export function isMac(customPlatform = null) {
  if (customPlatform !== null) {
    return /Mac|iPhone|iPod|iPad/i.test(customPlatform);
  }
  if (typeof navigator === 'undefined') return false;
  const platform = navigator.userAgentData?.platform || navigator.platform || navigator.userAgent || '';
  return /Mac|iPhone|iPod|iPad/i.test(platform);
}

export function getModKeyName(symbol = false, customPlatform = null) {
  if (isMac(customPlatform)) return symbol ? '⌘' : 'Cmd';
  return 'Ctrl';
}

export function getAltKeyName(symbol = false, customPlatform = null) {
  if (isMac(customPlatform)) return symbol ? '⌥' : 'Option';
  return 'Alt';
}

export function getShiftKeyName(symbol = false, customPlatform = null) {
  if (isMac(customPlatform) && symbol) return '⇧';
  return 'Shift';
}

export function formatShortcut(macShortcut, winShortcut, customPlatform = null) {
  return isMac(customPlatform) ? macShortcut : winShortcut;
}
